<div class="flex justify-center items-center w-full">

<form [formGroup]="rpe_dw_form" class="py-10 w-full max-w-full mx-auto px-4" (ngSubmit)="onSubmit()"  >


    <div class="flex flex-wrap lg:flex-nowrap justify-center gap-x-6 gap-y-4">

        <div class="w-full md:w-1/3 lg:w-1/4">
            <mat-form-field class="w-full min-w-[250px] max-w-[350px]">
                <mat-label>k value</mat-label>
                <input matInput placeholder="k value" formControlName="kVal" autocomplete="off">
            </mat-form-field>
        </div>

        <div class="w-full md:w-1/3 lg:w-1/4">
            <mat-form-field class="w-full min-w-[250px] max-w-[350px]">
                <mat-label>M<sub>1</sub></mat-label>     
                <input matInput formControlName="m1Val" autocomplete="off">
            </mat-form-field>
        </div>
 
        <div class="w-full md:w-1/3 lg:w-1/4">
            <mat-form-field class="w-full min-w-[250px] max-w-[350px]">
                <mat-label>Deflection angle (δ) (weak shock)</mat-label>     
                <input matInput formControlName="daVal" autocomplete="off">
            </mat-form-field>
        </div>
    </div>    

    <!-- Center the button below the fields -->
    <div class="flex justify-center mt-6">
        <button mat-raised-button type="submit" (click)="onSubmit()" [disabled]="rpe_dw_form.invalid">
            Calculate
        </button>
    </div>

</form>
</div>

<div *ngIf="osmBool" class="mt-10 flex justify-center">

    <table>
        <tr>
            <td>Shock angle </td>
            <td> {{ osTheta()  | number:'.1-5' }}°</td>
        </tr>
        <tr>
            <td>M<sub>2</sub></td>
            <td>{{ osM2() | number:'.1-5' }}</td>
        </tr>
        <tr>
            <td>p<sub>2</sub> / p<sub>1</sub></td>
            <td></td>
        </tr>

        <tr>
            <td>T<sub>2</sub> / T <sub>1</sub></td>
            <td></td>
        </tr>

        <tr> 
            <td>p<sub>0<sub>2</sub></sub> / p<sub>0<sub>1</sub></sub> </td>
            <td></td>
        </tr>

        <tr>
            <td>ρ<sub>2</sub> / ​ρ<sub>1</sub></td>
            <td></td>
        </tr>
    </table>

</div>